import axios from 'axios'

const apiUrl = import.meta.env.VITE_API_URL || 'https://inscricao.sabrieventos.tec.br/api/game';
// const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:7100/api/game';

const api = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json'
  }
});

export interface RegistrationFormData {
  name: string;
  email: string;
  document: string;
}

export interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
}

export interface DocumentCheckResponse {
  success: boolean;
  exists: boolean;
  message: string;
}

export const checkDocument = async (document: string): Promise<DocumentCheckResponse> => {
  const response = await api.get<DocumentCheckResponse>(`/registrations/check/${document}`);
  return response.data;
};

export const submitRegistration = async (data: RegistrationFormData): Promise<ApiResponse<any>> => {
  const response = await api.post<ApiResponse<any>>('/registrations', data);
  return response.data;
};

export default api; 